import { cn } from "@gettactic/helpers";
import { TacticLoader } from "../../loaders/TacticLoader/TacticLoader";
import React from "react";

export type LoadingSpinnerVariant = "tactic" | "circular";

export type LoadingSpinnerProps = {
  /**
   * The variant of the spinner
   * @default "tactic"
   */
  variant?: LoadingSpinnerVariant;
  /**
   * Use tailwind text colors
   */
  color?: string;
  /**
   * Append additional class names
   */
  className?: string;
};

const CircularLoader: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("h-4 w-4 animate-spin", className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    role="status"
    aria-label="Loading"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

/**
 * Loading spinner that can be used while data is loaded
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  variant = "tactic",
  color = "",
  className = ""
}) => {
  if (variant === "circular") {
    return <CircularLoader className={cn(color, className)} />;
  }

  // The loader paints its own blue unless told to follow the text colour
  return (
    <TacticLoader
      className={cn("inline-flex", color, className)}
      color={color ? "currentColor" : undefined}
    />
  );
};
